import React from "react";
import { Homepage } from "./pages/homepage";

function App() {
  return (
    <React.Fragment>
      <div>
        <Homepage />
      </div>
    </React.Fragment>
  );
}

export default App;
